import {
  FallBackImage,
  getContinueWatchListAPI,
  getStreamURI,
  ICardActionData,
  IMetadata,
  IVideoCardItemList,
  KissanEventType,
  useDiscoveryFeedStore,
  useProfileStore,
} from '@ninjacart/nc-nk-store';

import { AdaptiveCarousel, PlayListCard } from '@ninjacart/nc-nk-adaptive-cards';
import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import {
  // Image,
  ImageOrSvg,
  Paragraph,
  Progress,
  SizeTokens,
  Text,
  Trending,
  VideoPlayIconRegular,
  View,
  XStack,
  YStack,
} from '@ninjacart/nc-nk-ui';
import { AutoPlayVideo } from '@ninjacart/nc-nk-video';
import { BannerAds } from '@ninjacart/nc-nk-web-deps';
import { FlashList, ViewToken } from '@shopify/flash-list';
import { Eye } from '@tamagui/lucide-icons';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions, Platform, Pressable } from 'react-native';
import { Link } from 'solito/link';
// import { PlayListCard } from './playListCard';
import { useDiscoveryStore } from '../../store/useDiscoveryStore';
import { LinearGradient } from 'tamagui/linear-gradient';
import { usePathname } from 'solito/navigation';

export function VideoCardList(props: IVideoCardItemList) {
  const {
    horizontal,
    data,
    cardWidth,
    trendingFlag,
    renderItemType,
    fullView,
    isContinueWatchingView,
    index,
    isActiveFeedIndex,
  } = props;
  const [size, setSize] = useState(0.5);
  const [progress, setProgress] = useState(30);
  const sizeProp = `$${size}` as SizeTokens;
  const pathname = usePathname();
  const isVideoFocused = pathname === '/discover';
  const { t } = useTranslation();
  const screenWidth = Dimensions.get('window').width;
  const numColumns = horizontal ? undefined : Math.floor(screenWidth / cardWidth);
  const setEventDiscoveryFeedType = useDiscoveryStore((state) => state.setEventDiscoveryFeedType);
  const [onEndReachedSpinner, setOnEndReachedSpinner] = useState<boolean>(false);
  const [discoverMetaData, setDiscoverMetaData] = useState<ICardActionData[] | any>(
    data.actionData
  );
  const [playListData, setPlayListData] = useState<IMetadata>(data);
  const fetchingDataRef = useRef(false);
  const userProfile = useProfileStore((state) => state.userProfile);
  const streamUrl = getStreamURI();
  const [visibleItemIndex, setVisibleItemIndex] = useState<number | null>(null);
  const deviceWidth = Dimensions.get('window').width;
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const onEndReached = async () => {
    if (!fetchingDataRef.current && !horizontal) {
      try {
        setOnEndReachedSpinner(true);
        fetchingDataRef.current = true;
        if (isContinueWatchingView) {
          let payload = {
            start: discoverMetaData?.length,
          };
          const continueWatchList = await getContinueWatchListAPI(payload);
          if (continueWatchList?.data?.length) {
            setDiscoverMetaData([...discoverMetaData, ...continueWatchList?.data]);
          }
        }
      } catch (error) {
        console.error('On reached err => ', error);
      } finally {
        setOnEndReachedSpinner(false);
        fetchingDataRef.current = false;
      }
    }
    if (horizontal && renderItemType === 'medium') {
      handleContinueWatchScrollEvent();
    } else if (horizontal && renderItemType == 'small') {
      handleTrendingScrollEvent();
    }
  };

  const viewabilityConfig = {
    itemVisiblePercentThreshold: 50,
    minimumViewTime: 1000,
  };

  const captureImpressionEvent = (index: number, itemId: number | undefined) => {
    const dataViewedMoreThanOneSecEvent: INinjaEvent = {
      name: KissanEventType.DATA_VIEWED_MORETHAN_ONE_SECOND,
      screenDetails: { screen: 'discovery page' },
      eventParams: [addEventParam('scrolledIndex', index), addEventParam('itemId', itemId)],
    };
    enqueue(dataViewedMoreThanOneSecEvent);
    // console.log(`Impression event for item at index ${index} in discovery`);
  };

  const viewableItemsChanged = useCallback(
    ({ viewableItems }: { viewableItems: ViewToken[] }) => {
      if (viewableItems[0]?.index !== undefined) {
        const activeIndex = viewableItems[0].index as number;
        if (horizontal && renderItemType === 'medium' && activeIndex >= 5) {
          handleContinueWatchScrollEvent();
        } else if (horizontal && renderItemType == 'small' && activeIndex >= 5) {
          handleTrendingScrollEvent();
        }
      }

      if (viewableItems?.length > 0) {
        viewableItems.forEach((item) => {
          const index = item.index;
          const itemId = item?.item?.content?.videoid;
          if (index) {
            setVisibleItemIndex(index);
            captureImpressionEvent(index, itemId);
          }
        });
      }
    },
    [visibleItemIndex]
  );

  const handleTrendingScrollEvent = () => {
    const disTreandingScrollEvent: INinjaEvent = {
      name: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_TRENDING,
      screenDetails: { screen: 'discovery page' },
    };
    enqueue(disTreandingScrollEvent);
  };

  const handleContinueWatchScrollEvent = () => {
    const disContinueWatchScrollEvent: INinjaEvent = {
      name: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCH,
      screenDetails: { screen: 'discovery page' },
    };
    enqueue(disContinueWatchScrollEvent);
  };

  const handleClick = (item: ICardActionData) => {
    // push('/dicovery-longvideo');

    if (renderItemType == 'medium') {
      const additionalDetails = [
        addEventParam('clickedMediaUrl', item.mediaDetails[0]?.mediaUrl),
        addEventParam('videoType', playListData?.cardDetails?.name),
        addEventParam('videoId', item?.content?.videoid),
      ];
      const disContinueWatchClickEvent: INinjaEvent = {
        name: KissanEventType.DIS_CONTINUWATCH_CLICKED,
        screenDetails: { screen: 'discovery page' },
        eventParams: additionalDetails,
      };
      enqueue(disContinueWatchClickEvent);
    } else if (renderItemType === 'small') {
      const additionalDetails = [
        addEventParam('clickedMediaUrl', item.mediaDetails[0]?.mediaUrl),
        addEventParam('videoType', playListData?.cardDetails?.name),
        addEventParam('videoId', item?.content?.videoid),
      ];
      const disVideoClickEvent: INinjaEvent = {
        name: KissanEventType.DIS_VIDEO_CLICKED,
        screenDetails: { screen: 'discovery page' },
        eventParams: additionalDetails,
      };
      enqueue(disVideoClickEvent);
    }
    setEventDiscoveryFeedType(playListData?.cardDetails?.name);
  };

  function indicatorProgressContinueWatch(item) {
    const durationValue = item.props.filter((el) => el.key == 'duration')[0];
    const currentTimeValue = item.props.filter((el) => el.key == 'currentTime')[0];
    const conCatTime = (currentTimeValue.value / durationValue.value) * 100;
    return conCatTime;
  }

  const mediumRenderItem = ({ item, index }: { item: ICardActionData; index }) => {
    const videoItem = {
      sourceUrl: item?.content?.streamingPlaylists!,
      duration: item?.content?.duration!,
      thumbnailUrl: item?.mediaDetails?.[0]?.mediaUrl || '',
      videoId: item?.content?.videoid!,
    };
    // const videoUrl = `/${item?.content?.languageCode ?? 'en'}/v/${item?.content?.seoUrl ?? item?.content?.videoid}?screenName='discovery page'`;
    const videoUrl = `/watch?v=${item?.content?.videoid}&screenName='discovery page'`
    return (
      <>
        {isActiveFeedIndex && isVideoFocused ? (
          <Pressable onPress={() => handleClick(item)} testID={`kisan_tId_medium_card_${index}`}>
            <Link href={videoUrl} shallow>
              <AutoPlayVideo
                item={videoItem}
                index={index}
                activeFeedItemIndex={0}
                width={fullView ? '100%' : 320}
                height={210}
                screenName={'discovery'}
                children={renderMediumCard({ item, videoUrl })}
              />
              {/* <Text>{'loading'}</Text> */}
            </Link>
          </Pressable>
        ) : (
          renderMediumCard({ item, videoUrl })
        )}
      </>
    );
  };

  const renderMediumCard = ({ item, videoUrl }) => {
    return (
      <XStack
        flexDirection="row"
        display="flex"
        onPress={() => handleClick(item)}
        testID={`kisan_tId_medium-card-${index}`}
      >
        <Link href={videoUrl} shallow>
          <XStack
            height={210}
            width={fullView ? (Platform.OS == 'web' ? 340 : 380) : 320}
            marginBottom={15}
            marginRight={8}
          >
            <LinearGradient
              colors={['#222', '#17161652']}
              start={[0, 1]}
              end={[0, 0.6]}
              zIndex={999}
              backgroundColor="$overlaybg"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: 10,
                height: '100%',
              }}
            >
              {/* <Image
              style={{ height: 210, zIndex: -1, borderRadius: 10 }}
              source={{ uri: `${streamUrl}${item.mediaDetails[0].mediaUrl}` }}
              // resizeMode="cover"
              contentFit="cover"
            /> */}
              <ImageOrSvg
                height={210}
                borderRadius={10}
                uri={`${streamUrl}${item.mediaDetails[0].mediaUrl}`}
              />
              <View position="absolute" top="25%" left="44%">
                <View
                  width={50}
                  height={50}
                  backgroundColor="#A7A7A780"
                  borderRadius={50}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <VideoPlayIconRegular size={35} color={'$background'} />
                </View>
              </View>
              <View position="absolute" bottom={5} left={10} width="100%">
                <Progress
                  top={'$2'}
                  size={sizeProp}
                  value={Math.round(indicatorProgressContinueWatch(item))}
                  style={{
                    borderRadius: 10,
                    height: 2,
                    backgroundColor: '#EEE',
                    minHeight: 2,
                    marginBottom: 10,
                    width: '95%',
                  }}
                >
                  <Progress.Indicator animation="bouncy" backgroundColor={'#368665'} />
                </Progress>
                <Text
                  fontSize={16}
                  fontWeight={'500'}
                  color={'#FFF'}
                  marginBottom={2}
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  paddingRight={20}
                  paddingTop={2}
                >
                  {item.content.videoTitle}
                </Text>
                <XStack display="flex" justifyContent="space-between">
                  <Paragraph fontSize={14} fontWeight={'400'} color={'$lightGrey'}>
                    {item.content.authorName}
                  </Paragraph>
                  <XStack marginRight={20}>
                    <Eye
                      fontSize={14}
                      size={20}
                      fontWeight={'400'}
                      color={'$lightGrey'}
                      position="relative"
                      top={2}
                    />
                    <Paragraph
                      fontSize={14}
                      fontWeight={'400'}
                      color={'$lightGrey'}
                      paddingLeft={3}
                    >
                      {item.content.viewCount} {t('page.views')}
                    </Paragraph>
                  </XStack>
                </XStack>
              </View>
            </LinearGradient>
          </XStack>
        </Link>
      </XStack>
    );
  };

  const smallRenderItem = ({ item, index }: { item: ICardActionData; index: number }) => {
    const videoItem = {
      sourceUrl: item?.content?.streamingPlaylists!,
      duration: item?.content?.duration!,
      thumbnailUrl: item?.mediaDetails?.[0]?.mediaUrl || '',
      videoId: item?.content?.videoid ?? '',
    };
    // const videoUrl = `/${item?.content?.languageCode ?? 'en'}/v/${item?.content?.seoUrl ?? item?.content?.videoid}?screenName='discovery page'`;
    const videoUrl = `/watch?v=${item?.content?.videoid}&screenName='discovery page'`
    return (
      <>
        {isActiveFeedIndex && isVideoFocused ? (
          <Pressable onPress={() => handleClick(item)}>
            <Link href={videoUrl} shallow>
              <AutoPlayVideo
                item={videoItem}
                index={index}
                activeFeedItemIndex={0}
                width={230}
                height={160}
                screenName={'discovery'}
                children={renderSmallCard({ item, index, videoUrl })}
              />
            </Link>
          </Pressable>
        ) : (
          renderSmallCard({ item, index, videoUrl })
        )}
      </>
    );
  };

  const renderSmallCard = ({ item, index, videoUrl }) => {
    return (
      <XStack
        flexDirection="row"
        display="flex"
        onPress={() => handleClick(item)}
        paddingLeft={1}
        testID={`kisan_tId_medium_card_${index}`}
      >
        <Link href={videoUrl} shallow>
          <XStack
            height={160}
            width={cardWidth}
            marginBottom={15}
            marginRight={8}
            position="relative"
          >
            {trendingFlag && (
              <XStack
                style={{
                  position: 'absolute',
                  top: -9,
                  left: -3,
                  right: 0,
                  bottom: 0,
                  zIndex: 22222,
                }}
              >
                <Trending width={38} height={35} />
                <Paragraph
                  fontSize={14}
                  fontWeight={'600'}
                  color={'#FFF'}
                  style={{
                    position: 'absolute',
                    alignItems: 'center',
                    justifyContent: 'center',
                    top: 5,
                    left: 9,
                    right: 0,
                    bottom: 0,
                  }}
                >
                  #{index + 1}
                </Paragraph>
              </XStack>
            )}
            <LinearGradient
              colors={['#222', '#17161652']}
              start={[0, 1]}
              end={[0, 0.6]}
              zIndex={999}
              backgroundColor="$overlaybg"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: 10,
                height: '100%',
              }}
            >
              <ImageOrSvg
                height={150}
                borderRadius={10}
                uri={item.mediaDetails[0]?.mediaUrl ?? FallBackImage}
              />

              {/* <Image
              style={{ height: 150, zIndex: -1, borderRadius: 10 }}
              contentFit="cover"
              source={{ uri: item.mediaDetails[0].mediaUrl }}
            /> */}
              <View style={{ position: 'absolute', top: '35%', left: '43%' }}>
                <VideoPlayIconRegular size={30} color={'$background'} />
              </View>
              <View
                style={{
                  position: 'absolute',
                  bottom: 3,
                  left: 10,
                  width: '100%',
                  backgroundColor: '',
                }}
              >
                <XStack marginBottom={1}>
                  <Eye
                    fontSize={14}
                    size={20}
                    fontWeight={'400'}
                    color={'$lightGrey'}
                    position="relative"
                    top={2}
                  />
                  <Paragraph fontSize={14} fontWeight={'400'} color={'$lightGrey'} paddingLeft={3}>
                    {item.content.viewCount} {t('page.views')}
                  </Paragraph>
                </XStack>
                <Text
                  fontSize={16}
                  fontWeight={'500'}
                  color={'#FFF'}
                  marginBottom={1}
                  ellipsizeMode="tail"
                  numberOfLines={1}
                  paddingRight={20}
                >
                  {item.content.videoTitle}
                </Text>
                <Paragraph fontSize={14} fontWeight={'400'} color={'$lightGrey'}>
                  {item.content.authorName}
                </Paragraph>
              </View>
            </LinearGradient>
          </XStack>
        </Link>
      </XStack>
    );
  };

  if (renderItemType === 'small') {
    return (
      <YStack width={'100%'}>
        <FlashList
          data={discoverMetaData}
          renderItem={smallRenderItem}
          keyExtractor={(item, index) => index.toString()}
          horizontal={horizontal}
          showsHorizontalScrollIndicator={false}
          estimatedItemSize={200}
          numColumns={numColumns}
          onEndReached={onEndReached}
          viewabilityConfig={viewabilityConfig}
          onViewableItemsChanged={viewableItemsChanged}
          extraData={isActiveFeedIndex}
        />
      </YStack>
    );
  }

  if (renderItemType === 'medium') {
    return (
      <YStack width="100%">
        <FlashList
          data={discoverMetaData}
          renderItem={mediumRenderItem}
          keyExtractor={(item, index) => index.toString()}
          horizontal={horizontal}
          showsHorizontalScrollIndicator={false}
          estimatedItemSize={200}
          numColumns={numColumns}
          onEndReached={onEndReached}
          viewabilityConfig={viewabilityConfig}
          onViewableItemsChanged={viewableItemsChanged}
          extraData={isActiveFeedIndex}
        />
      </YStack>
    );
  }
  if (renderItemType == 'ads') {
    return (
      <YStack width={'100%'}>
        <BannerAds
          deviceWidth={deviceWidth}
          unitId={discoverMetaData?.content?.unitId}
          itemKey={discoverMetaData?.content?.itemKey ?? index!.toString()}
          bannerAdKeywords={discoverMetaData?.content?.tags}
          screenName={'discovery page'}
        />
      </YStack>
    );
  }

  if (renderItemType === 'carousel') {
    return (
      <YStack width={'100%'}>
        <AdaptiveCarousel carouselData={data?.actionData} sourcePage={'feed'} />
      </YStack>
    );
  }

  return (
    <YStack width={'100%'}>
      <PlayListCard horizontal={true} cardWidth={118} data={playListData} />
    </YStack>
  );
}
